import { Text } from '@ui/themed';
export function DetailRow({ label, value }: { label: string; value?: string | null }) {
  return (
    value && (
      <div className="flex gap-2">
        <Text>{label}</Text>
        <Text variant="secondary" truncate>
          {value}
        </Text>
      </div>
    )
  );
}
